import './NoteBadge.scss';
import React from 'react';
import { ErrorIcon } from 'src/modules/common/icons/ErrorIcon';

type Props = {
  readonly content: React.ReactNode;
};

export const NoteBadge = ({ content }: Props): React.ReactElement => (
  <div className="bp-note-badge">
    <div className="bp-note-badge__icon">
      <ErrorIcon/>
    </div>
    {content}
  </div>
);
